module.exports = __webpack_public_path__ + "img/Wp_2051.06b29040.png";